/**
 * @desc 编辑sku主体信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(body: defs.basics.PlmSkuEditRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/editSkuMain`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
